import JwtService from "@/utils/jwt.service";
import ApiService from "@/utils/api.service";

export default {
    login(context, credentials) {
        return new Promise((resolve, reject) => {
            context.commit("setLoading", true);
            ApiService.post("auth/login", credentials)
                .then(({ data }) => {
                    if (data.error) {
                        console.log("error");
                    } else if (data.token) {
                        context.commit("setAuth", data);
                        resolve(data);
                    }
                })
                .catch(error => {
                    reject(error)
                })
                .finally(() => {
                    context.commit("setLoading", false);
                });
        });
    },
    logout(context) {
        context.commit("purge_auth");
    },

    check_auth(context) {
        if (JwtService.getToken()) {
            ApiService.setHeader();
            ApiService.get("user").then(({ data }) => {
                if (data.message) {
                    context.commit("purge_auth");
                } else {
                    context.commit("setUser", data);
                }
            });
        } else {
            context.commit("purge_auth");
        }
    },
}